import { FunctionComponent } from 'react';
import { styled, Typography, TypographyProps } from '@mui/material';

type SizeVariant = 'section' | 'subSection';

const getSize = (variant: SizeVariant): TypographyProps['variant'] =>
    variant === 'section' ? 'h5' : 'subtitle1';

export type TitleProps = {
    children: TypographyProps['children'];
};

export const Title: FunctionComponent<React.PropsWithChildren<TitleProps>> = ({
    children,
}) => <Typography variant='h4'>{children}</Typography>;

export const SectionTitle: FunctionComponent<
    React.PropsWithChildren<{
        children: TypographyProps['children'];
        variant?: SizeVariant;
    }>
> = ({ children, variant = 'section' }) => (
    <Typography variant={getSize(variant)}>{children}</Typography>
);

export const RequiredMark: FunctionComponent<
    React.PropsWithChildren<unknown>
> = () => (
    <Typography component='span' color='error'>
        *
    </Typography>
);

export const BoldLabel: FunctionComponent<TypographyProps> = styled((props) => (
    <Typography component='span' {...props} />
))(() => ({
    fontWeight: 600,
}));
